import { usePage } from '@inertiajs/vue3';

import type { Permission } from '@/lib/permissions';
import type { AuthenticatedPageProps } from '@/types/inertia';

export function hasPermission(value: Permission): boolean {
    const { can } = usePermissions();
    return can(value);
}

export function hasRole(value: string): boolean {
    const { is } = usePermissions();
    return is(value);
}

export default function usePermissions() {
    const page = usePage<AuthenticatedPageProps>();
    const permissions: Permission[] = page.props.auth?.user?.permissions ?? [];
    const roles: string[] = page.props.auth?.user?.roles ?? [];

    const can = function (value: Permission): boolean {
        if (roles.includes('superadmin')) {
            return true;
        }
        if (!Array.isArray(permissions)) {
            return false;
        }
        return permissions.includes(value);
    };

    const is = function (value: string): boolean {
        let result = false;
        if (roles.includes('superadmin')) {
            return true;
        }
        if (!Array.isArray(roles)) {
            return false;
        }
        if (value.includes('|')) {
            value.split('|').forEach(function (item: string) {
                if (roles.includes(item.trim())) {
                    result = true;
                }
            });
        } else if (value.includes('&')) {
            result = true;
            value.split('&').forEach(function (item: string) {
                if (!roles.includes(item.trim())) {
                    result = false;
                }
            });
        } else {
            result = roles.includes(value.trim());
        }
        return result;
    };

    return {
        roles,
        permissions,
        can,
        is,
    };
}
